import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ec09f99")

_pushScopeId("data-v-2ec09f99")
const _hoisted_1 = { class: "summary__table" }
const _hoisted_2 = { class: "summary__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "col__team" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-team" }),
  /*#__PURE__*/_createTextVNode(" / "),
  /*#__PURE__*/_createVNode("i", { class: "icon-user-o" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "col__total" }, "Total", -1)
const _hoisted_5 = { class: "summary__body" }
const _hoisted_6 = {
  key: 0,
  class: "col__team"
}
const _hoisted_7 = {
  key: 0,
  class: "icon-spinner animate-spin"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "col__total" }
const _hoisted_10 = { class: "summary__footer" }
const _hoisted_11 = { class: "summary__counts" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "col__team" }, "Total", -1)
const _hoisted_13 = {
  key: 0,
  class: "icon-spinner animate-spin"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "col__total" }
const _hoisted_16 = {
  key: 0,
  class: "icon-spinner animate-spin"
}
const _hoisted_17 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedRoles, (role) => {
        return (_openBlock(), _createBlock("span", {
          key: role,
          class: "col__role"
        }, [
          _createVNode("img", {
            src: _ctx.roleImg(role)
          }, null, 8, ["src"])
        ]))
      }), 128)),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teams, (team, idx) => {
        return (_openBlock(), _createBlock("div", {
          key: idx,
          class: "summary__counts"
        }, [
          (team === _ctx.NO_TEAMS)
            ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(team), 1))
            : (_openBlock(), _createBlock(_component_TeamLabel, {
                key: 1,
                team: _ctx.getTeam(team),
                class: "col__team"
              }, null, 8, ["team"])),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedRoles, (role) => {
            return (_openBlock(), _createBlock("span", {
              key: role,
              class: "col__role"
            }, [
              (_ctx.userLoading)
                ? (_openBlock(), _createBlock("i", _hoisted_7))
                : (_ctx.userReady)
                  ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.userCount[team][role]), 1))
                  : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.roleTotalPerTeam[team]), 1)
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedRoles, (role) => {
          return (_openBlock(), _createBlock("span", {
            key: role,
            class: "col__role"
          }, [
            (_ctx.userLoading)
              ? (_openBlock(), _createBlock("i", _hoisted_13))
              : (_ctx.userReady)
                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.roleTotal[role]), 1))
                : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode("span", _hoisted_15, [
          (_ctx.userLoading)
            ? (_openBlock(), _createBlock("i", _hoisted_16))
            : (_ctx.userReady)
              ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.totalUsers), 1))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})